import Api from '../api/config';
import Vue from 'vue';

const ClientKeyMap = {};
const keyMap = JSON.parse(sessionStorage.getItem('key_map'));
if (!keyMap) {
  Api.post('/public/key-map', {})
    .then((json) => {;
      Vue.prototype.$session.save('key_map', json.key_map);
      json.key_map.forEach((item) => {
        if (ClientKeyMap[item.t] === undefined) {
          ClientKeyMap[item.t] = {};
        }
        ClientKeyMap[item.t][item.k] = item.v;
      });
    });
} else {
  keyMap.forEach((item) => {
    if (ClientKeyMap[item.t] === undefined) {
      ClientKeyMap[item.t] = {};
    }
    ClientKeyMap[item.t][item.k] = item.v;
  });
}
export default {
  AJAX_STATUS: {
    YES: '',
  },
  PATIENT_TYPE: {
    OFFLINE: 1, // 线下
    GRAPHIC: 2, // 图文
    VIDEO: 4, // 视频
  },
  PAGING: {
    PAGE: 1, // 分页开始页码数
  },
  ClientKeyMap, // 字典值{t: []}
  /**
   * 返回字典值
   * @param t 类型
   * @param k 键
   * @returns string
   */
  getValue(t, k) {
    if (k === undefined) {
      return '';
    }
    if (this.ClientKeyMap[t] === undefined || this.ClientKeyMap[t][k] === undefined) {
      return `${t}:${k}`;
    }
    return this.ClientKeyMap[t][k];
  },
  /**
   * 返回字典列表
   * @param t 类型
   */
  getValues(t) {
    return this.ClientKeyMap[t];
  },
};



// WEBPACK FOOTER //
// ./src/utils/KeyMap.js